import Relation from './relation.vue';
import Range from './contain_form.vue';
import CheckList from './check_list.vue';

export default Relation;
export { Range, CheckList };
